import type { ReactNode } from 'react';

/**
 * Rahmen aller Seiten.
 *
 * **Der `.page`-Wrapper ist nicht Deko.** `.bg`/`.bg-calm` sind
 * `position: fixed; z-index: 0` und damit positioniert; nicht positionierter
 * Inhalt wird davon überdeckt. Erst `.page` (`position: relative; z-index: 10`)
 * hebt den Inhalt darüber. Ohne den Wrapper sieht man genau das, was hier
 * einmal passiert ist: den Hintergrund, sonst nichts.
 *
 * Deshalb liegt der Rahmen in einer Komponente und nicht als lose Divs in
 * `App.tsx` – so kann keine Seite versehentlich daran vorbei gerendert werden.
 *
 * Hintergrund bewusst „calm" (Design-System §6): Verlauf und Scanlines, kein
 * Grid, keine Sonne. Der volle Synthwave-Look bleibt Login und Homescreen des
 * Hubs vorbehalten.
 */
export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="page">
      <div className="bg-calm" aria-hidden="true" />
      <div className="bg__scanlines" aria-hidden="true" />
      <main className="page__main">{children}</main>
    </div>
  );
}
